export default __webpack_public_path__ + "static/media/CCA.1cdaf2d0.png";